import { createReducer } from '@reduxjs/toolkit';
import type { CommissionFormValues } from '@/components/~advisor/Trading/Trading/CustomCommissionModal';
import { saveCommissionState, clearCommissionState } from './tradingActions';

export interface TradingState {
    savedCommissionState: CommissionFormValues | null;
}

export const TRADING_REDUCER_DEFAULT_STATE: TradingState = {
    savedCommissionState: null,
};

export const tradingReducer = createReducer(TRADING_REDUCER_DEFAULT_STATE, (builder) => {
    builder.addCase(saveCommissionState, (state, action) => {
        state.savedCommissionState = action.payload;
    });
    builder.addCase(clearCommissionState, (state) => {
        state.savedCommissionState = null;
    });
});
